import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '../../types';

export const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: 'var(--app-vh, 100vh)',
        background: `linear-gradient(135deg, ${theme.palette.primary.main}15 0%, ${theme.palette.grey[50]} 50%, ${theme.palette.primary.main}08 100%)`,
        textAlign: 'center',
        padding: theme.spacing(3)
    },
    iconCircle: {
        width: 100,
        height: 100,
        borderRadius: '50%',
        backgroundColor: theme.palette.primary.main,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: theme.spacing(4),
        boxShadow: `0 8px 32px ${theme.palette.primary.main}30`,
        animation: '$pulse 2s ease-in-out infinite'
    },
    icon: {
        fontSize: 48,
        color: '#fff'
    },
    title: {
        fontWeight: 700,
        fontSize: '2rem',
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(2)
    },
    subtitle: {
        fontSize: '1.1rem',
        color: theme.palette.text.secondary,
        maxWidth: 480,
        lineHeight: 1.6
    },
    '@keyframes pulse': {
        '0%, 100%': {
            transform: 'scale(1)',
            boxShadow: `0 8px 32px ${theme.palette.primary.main}30`
        },
        '50%': {
            transform: 'scale(1.05)',
            boxShadow: `0 12px 40px ${theme.palette.primary.main}40`
        }
    }
}));
